<template>
  <div>
    <page-header
      title="Create Designation"
      breadcrumb="Dashboard >> Settings >> Organization Hierarchy >> Create Designation"
    />
    <div class="new-function-form-wrapper card">
      <div class="new-function-form__details">
        <p class="text-primary-yellow font-semibold pb-4">New Designation</p>
        <div class="flex gap-2">
          <p class=" font-medium pb-4">Which of these best describes the designation?</p>
            <label for="true" class="radio-label">
              <input
                type="radio"
                id="true"
                :value="true"
                v-model="newDesignation.isSupervisory"
              />
              Supervisory
              <span></span>
            </label>

            <label for="false" class="radio-label">
              <input
                type="radio"
                id="false"
                :value="false"
                v-model="newDesignation.isSupervisory"
              />
              Non Surpervisory
              <span></span>
            </label>
        </div>
      </div>
       <hr class="mb-2"  />
      <div class="designation__details">
        <p class="text-primary-yellow font-semibold pb-3">
          Designation Details
        </p>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Title</label>
              <input type="text" class="input" v-model="newDesignation.name" />
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Function</label>
              <el-select
                v-model="newDesignation.functionId"
                placeholder="Select"
              >
                <el-option
                  v-for="selectedFunction in functions"
                  :key="selectedFunction.id"
                  :label="selectedFunction.name"
                  :value="selectedFunction.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Job Level</label>
              <el-select v-model="newDesignation.levelId" placeholder="Select">
                <el-option
                  v-for="level in jobLevels"
                  :key="level.id"
                  :label="level.name"
                  :value="level.id"
                >
                </el-option>
              </el-select>
            </div>
            <!-- <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Dotted Reporting</label>
              <el-select
                v-model="newDesignation.dottedReportingTo"
                placeholder="Select"
              >
                <el-option
                  v-for="designation in designations"
                  :key="designation.id"
                  :label="designation.name"
                  :value="designation.id"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Cost Centre</label>
              <input
                type="number"
                class="input"
                v-model="newDesignation.costCentre"
              />
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Reporting To</label>
              <el-select
                v-model="newDesignation.reportingTo"
                placeholder="Select"
              >
                <el-option
                  v-for="designation in designations"
                  :key="designation.id"
                  :label="designation.name"
                  :value="designation.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-2" />
      <div class="designation__salary-band">
        <p class="text-primary-yellow font-semibold pb-3">
          Annual Salary Bands
        </p>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Lower Salary Band (&#8358;)</label>
              <input
                type="number"
                class="input"
                @keypress="isNumber($event)"
                v-model.number="newDesignation.lowerAnnualSalaryBand"
              />
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Upper Salary Band (&#8358;)</label>
              <input
                type="number"
                class="input"
                @keypress="isNumber($event)"
                v-model.number="newDesignation.upperAnnualSalaryBand"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="button-wrapper">
        <button
          class="button"
          @click="$router.push({ name: 'OrganizationHierarchy' })"
        >
          Cancel
        </button>
        <primary-button buttonText="save" @click="createDesignation" :loading="creatingDesignation" :disabled="disableButton"/>
      </div>
    </div>

    <import-KPA-modal
      v-if="importKPA"
      :showModal="importKPA"
      @import-kpis="importKPI"
      @close-modal="importKPA = false"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components:{
    PageHeader
  },
  data() {
    return {
      newDesignation: {
        name: "",
        isSupervisory: true,
        functionId: "",
        costCentre: 0,
        levelId: "",
        reportingTo: "",
        // dottedReportingTo: "",
        lowerAnnualSalaryBand: 0,
        upperAnnualSalaryBand: 0,
      },
      creatingDesignation: false,
      functions: [{ name: "Nil", id: null }],
      designations: [{ name: "Nil", id: null }],
      jobLevels: [{ name: "Nil", id: null }],
    // 'name': ' tobi designation',
    // 'isSupervisory': ' false',
    // 'functionId': 'cb369aeb-c763-4898-830f-9942f1f9609b',
    // 'levelId': '8ca6fce2-0d2e-4fee-93ae-5d4cb76238ca',
    //    'costCentre': ' 100000',
    // 'reportingTo': '0a1b8eb8-00c5-4c95-ba18-0fbe888f7b25',
    // 'createdBy': '671b8045-d34e-49d6-9822-577054052592',
    // 'lowerAnnualSalaryBand': ' 100000',
    // 'upperAnnualSalaryBand': '200000'
    // 'orgId': 'b8dbee24-2c80-4cb2-8db6-6cca1e6f91c0',
    };
  },
  mounted() {
    this.getFunctions();
    this.getDesignations();
    this.getJobLevels();
  },
  watch: {
    "newDesignation.functionId"() {
      let { functionId } = this.newDesignation;
      if (functionId) {
        let selectedFunction = this.functions.filter((item) => {
          return item.id == functionId;
        });
        this.newDesignation.costCentre = selectedFunction[0].costCenter;
      } else {
        this.newDesignation.costCentre = "Nil";
      }
    },
  },
  computed: {
    disableButton() {
      let { name, costCentre, lowerAnnualSalaryBand, upperAnnualSalaryBand } = this.newDesignation;
      if (
        name.length &&
        costCentre > 0 &&
        lowerAnnualSalaryBand > 0 &&
        upperAnnualSalaryBand > 0 
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    async createDesignation() {
      this.creatingDesignation = true;
      try {
        let response = await this.$_createDesignation(this.newDesignation);
        console.log(response);
        this.generateToast("Designation successfully created!", "success");
        this.resetInputFields();
        this.getDesignations();
        this.creatingDesignation = false;
        this.$router.push({ name: "OrganizationHierarchy" });
      } catch (error) {
        this.handleError(error);
        this.creatingDesignation = false;
      }
    },
    async getFunctions() {
      try {
        let response = await this.$_getAllFunctions();
        console.log(response);
        let functions = response.data.functions;
        this.functions = this.functions.concat(functions);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getDesignations() {
      try {
        let response = await this.$_getAllDesignations();
        console.log(response);
        let designations = response.data.designations;
        this.designations = [{ name: "Nil", id: null }];
        this.designations = this.designations.concat(designations);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getJobLevels() {
      try {
        let response = await this.$_getJobLevels();
        console.log(response);
        let jobLevels = response.data.levels;
        this.jobLevels = this.jobLevels.concat(jobLevels);
      } catch (error) {
        this.handleError(error);
      }
    },
    resetInputFields() {
      this.newDesignation = {
        name: "",
        isSupervisory: true,
        functionId: "",
        costCentre: "",
        levelId: "",
        reportingTo: "",
        dottedReportingTo: "",
        lowerAnnualSalaryBand: "",
        upperAnnualSalaryBand: "",
      };
    },
    
  },
};
</script>

<style lang="scss" scoped>
.kpi-input {
  width: 70%;
}

tr:first-child td:first-child {
  border-top-left-radius: 10px;
}
tr:first-child td:last-child {
  border-top-right-radius: 10px;
}
tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}
.table__search-input-wrapper {
  background: #7b858f10;
  width: 20vw;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }
  > div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>
